import type { PublicCollectionItem, PublicCollectionItem_ListItem } from "@/services/collection/item/public/publicCollectionItemTypes";
import type { MarketplaceItem } from "@/services/marketplace/item/marketplaceItemTypes";
import type { Ref } from "vue";

export function usePublicCollectionItemStatus(item: Ref<PublicCollectionItem_ListItem | PublicCollectionItem | undefined>) {
  // Some cleanup would be nice - API rework needed, or PublicCollectionItem into zod rework needed.
  const marketplaceItem = computed((): MarketplaceItem | undefined => {
    if (item.value === undefined) {
      return undefined;
    }

    let mi: MarketplaceItem | null = null;
    if ("marketplaceItem" in item.value) {
      mi = item.value.marketplaceItem;
    } else if ("marketPlaceItem" in item.value) {
      mi = item.value.marketPlaceItem;
    }

    if (mi !== null && mi !== undefined && mi.quantity > 0) {
      return mi;
    } else {
      return undefined;
    }
  });

  const isForSale = computed(() => marketplaceItem.value !== undefined);

  return {
    marketplaceItem,

    isForSale,
  };
}
